import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@client/components/admin/shared';
import { ActivityTable } from '@client/components/admin/activity-table';

export const Route = createFileRoute('/admin/activity')({
  component: () => (
    <>
      <PageHeader title="Activity log" eyebrow="Everything, append-only" />
      <div className="px-6 py-6 md:px-8"><ActivityTable showExport /></div>
    </>
  ),
});
